module.exports = __webpack_public_path__ + "h5/img/banner2.0670f605.png";